import chroma from 'chroma-js';

export const calculateColorBrightness = (color) => {
  // Variables for red, green, blue values
  let r; let g; let b;

  // Check the format of the color, HEX or RGB?
  if (color.match(/^rgb/)) {
    // If HEX --> store the red, green, blue values in separate variables
    color = color.match(/^rgba?\((\d+),\s*(\d+),\s*(\d+)(?:,\s*(\d+(?:\.\d+)?))?\)$/);

    r = color[1];
    g = color[2];
    b = color[3];

  } else {
    // If RGB --> Convert it to HEX: http://gist.github.com/983661
    color = +(`0x${color.slice(1).replace(
      color.length < 5 && /./g, '$&$&',
    )}`);

    r = color >> 16;
    // eslint-disable-next-line
      g = color >> 8 & 255;
    b = color & 255;
  }

  // HSP (Highly Sensitive Poo) equation from http://alienryderflex.com/hsp.html
  const hsp = Math.sqrt(
    0.299 * (r * r)
    + 0.587 * (g * g)
    + 0.114 * (b * b),
  );

  // Using the HSP value, determine whether the color is light or dark
  if (hsp > 127.5) {
    return 'light';
  }

  return 'dark';

};

export const getBackgroundContrastedColor = (hex) => {

  if (!hex) return hex;

  const color = chroma(hex.toUpperCase());

  return color.alpha(0.15).css();

};

export const hexToRGBA = (hex, opacity) => {

  let c;

  if (/^#([A-Fa-f0-9]{3}){1,2}$/.test(hex)) {

    c = hex.substring(1).split('');

    if (c.length === 3) {
      c = [c[0], c[0], c[1], c[1], c[2], c[2]];
    }

    c = `0x${c.join('')}`;

    return `rgba(${[(c >> 16) & 255, (c >> 8) & 255, c & 255].join(',')},${opacity})`;

  } else {
    //If hex value is not valid then simply return the original value
    return hex;
  }

};

export const isRgbaColor = (value) => {

  const rgbaRegex = /^rgba\(\s*\d+\s*,\s*\d+\s*,\s*\d+\s*,\s*(0(\.\d+)?|1(\.0+)?)\s*\)$/;

  return rgbaRegex.test(value);

};
